import React, { useEffect } from 'react';
import { Route, Routes, useLocation } from 'react-router-dom';
import { ProtectedRoute } from './ProtectedRoute';
// import DashboardContainer from '../Screen/Dashboard/index';
import 'react-toastify/dist/ReactToastify.css';
import { MaintenanceRoute } from './MaintenanceRoute';
import MaintenanceLayout from '../Screen/Layouts/MaintenanceLayout';
import { ToastContainer } from 'react-toastify';
import Login from '../Screen/Login/login';
import Home from '../Screen/Home';
import Signup from '../Screen/Signup/Signup';
import DashboardContainer from '../Screen/Dashboard/Dashboard';
import ProfileContainer from '../Screen/Profile/Profile';
import AccountContainer from '../Screen/Account/Account';
import BusinessIdeasContainer from '../Screen/BusinessIdeas/BusinessIdeas';
import BusinessPlanContainer from '../Screen/BusinessPlan/BusinessPlan';
import ProContainer from '../Screen/Pro/Pro';
import FilterContainer from '../Screen/Filter/Filter';
import ResearchContainer from '../Screen/Reasearch/Research';
import IdeaDetailsContainer from '../Screen/IdeaDetails/IdeaDetails';
import IdeaSharePage from '../Screen/IdeaShare/IdeaSharePage';
import WorkspaceContainer from '../Screen/Workspace/Workspace';
import InvitationContainer from '../Screen/Invite/InvitationContainer';
import CareerPathwayContainer from '../Screen/CareerPathway/CareerPathwayContainer';
import PaymentSuccessContainer from '../Screen/PaymentSuccess/PaymentSuccessContainer';
import PaymentFailureContainer from '../Screen/PaymentSuccess/PaymentFailureContainer';
import JobCenterContainer from '../Screen/JobCenter/JobCenterContainer';
import StudentsContainer from '../Screen/Students/StudentsContainer';
import ConsultantsContainer from '../Screen/Consultants/ConsultantsContainer';
import { trackPageChange } from '../amplitude';
const TrackPageView = ({ children }) => {
  const location = useLocation();
  useEffect(() => {
    trackPageChange(location.pathname);
  }, [location]);
  return children;
};
const AllRoutes = ({ user, isMaintenance }) => {
  return (
    <>
      <ToastContainer />
      <Routes>
        {/* @ts-ignore */}
        <Route element={<MaintenanceRoute isMaintenance={isMaintenance} />}>
          {/* ============= LOGEDOUT ROUTES ========== */}
          {/* <Route index element={<Navigate to={'/app'} />} />
          <Route path="app"> */}
          <Route
            index
            element={
              <TrackPageView>
                <Home />
              </TrackPageView>
            }
          />
          <Route
            path="login"
            element={
              <TrackPageView>
                <Login />
              </TrackPageView>
            }
          />
          <Route
            path="signup"
            element={
              <TrackPageView>
                <Signup />
              </TrackPageView>
            }
          />
          <Route path="idea/:id" element={<IdeaSharePage />} />
          {/* <Route path="create-account" element={<SignupForm />} />

            {/* </Route> */}
          {/* ============= LOGEDIN ROUTES ========== */}
          {/* @ts-ignore */}
          <Route element={<ProtectedRoute isAllowed={!!user} />}>
            {/* <Route
              path="dashboard"
              element={
                <TrackPageView>
                  <DashboardContainer />
                </TrackPageView>
              }
            /> */}
            <Route
              path="profile"
              element={
                <TrackPageView>
                  <ProfileContainer />
                </TrackPageView>
              }
            />
            <Route
              path="account"
              element={
                <TrackPageView>
                  <AccountContainer />
                </TrackPageView>
              }
            />
            <Route
              path="businessideas"
              element={
                <TrackPageView>
                  <BusinessIdeasContainer />
                </TrackPageView>
              }
            />
            <Route
              path="businessideas/:id"
              element={<IdeaDetailsContainer />}
            />
            <Route
              path="businessplan"
              element={
                <TrackPageView>
                  <BusinessPlanContainer />
                </TrackPageView>
              }
            />
            {/* <Route
              path="pro"
              element={
                <TrackPageView>
                  <ProContainer />
                </TrackPageView>
              }
            /> */}
            <Route
              path="filter"
              element={
                <TrackPageView>
                  <FilterContainer />
                </TrackPageView>
              }
            />
            <Route
              path="research"
              element={
                <TrackPageView>
                  <ResearchContainer />
                </TrackPageView>
              }
            />
            <Route
              path="workspace"
              element={
                <TrackPageView>
                  <WorkspaceContainer />
                </TrackPageView>
              }
            />
            <Route
              path="invite"
              element={
                <TrackPageView>
                  <InvitationContainer />
                </TrackPageView>
              }
            />
            <Route
              path="careerpathway"
              element={
                <TrackPageView>
                  <CareerPathwayContainer />
                </TrackPageView>
              }
            />
            <Route
              path="jobCenter"
              element={
                <TrackPageView>
                  <JobCenterContainer />
                </TrackPageView>
              }
            />
            <Route
              path="paymentSuccess"
              element={
                <TrackPageView>
                  <PaymentSuccessContainer />
                </TrackPageView>
              }
            />
            <Route
              path="paymentFailure"
              element={
                <TrackPageView>
                  <PaymentFailureContainer />
                </TrackPageView>
              }
            />
            <Route
              path="students"
              element={
                <TrackPageView>
                  <StudentsContainer />
                </TrackPageView>
              }
            />
            <Route
              path="consultants"
              element={
                <TrackPageView>
                  <ConsultantsContainer />
                </TrackPageView>
              }
            />
          </Route>
        </Route>
        {/* ============= COMMON ROUTES ========== */}

        {/* </Route> */}
        <Route path="*" element={<h1>404 Page Not Found</h1>} />
        <Route path="maintenance" element={<MaintenanceLayout />} />
      </Routes>
    </>
  );
};

export default AllRoutes;
